import { createSelector } from 'reselect'

import { selectQbrState } from './selectQbrState'

export const selectQBRIsGlobalPlans = createSelector(
  [selectQbrState],
  (state) => state.documentSettings.isGlobalPlans
)
